module.exports = __webpack_public_path__ + "img/group-chat1.8427d65e.png";